import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, ProtectedRoute, LoginPage, DashboardLayout } from './AdminApp';

// Pages
import Dashboard from './pages/Dashboard';
import HeroEditor from './pages/HeroEditor';
import AboutEditor from './pages/AboutEditor';
import ProjectsEditor from './pages/ProjectsEditor';
import ContactEditor from './pages/ContactEditor';
import MessagesPage from './pages/MessagesPage';
import Settings from './pages/Settings';

const AdminRoutes = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <Routes>
                  <Route index element={<Dashboard />} />
                  <Route path="hero" element={<HeroEditor />} />
                  <Route path="about" element={<AboutEditor />} />
                  <Route path="projects" element={<ProjectsEditor />} />
                  <Route path="contact" element={<ContactEditor />} />
                  <Route path="messages" element={<MessagesPage />} />
                  <Route path="settings" element={<Settings />} />
                  <Route path="*" element={<Navigate to="/admin" replace />} />
                </Routes>
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  );
};

export default AdminRoutes;
